import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { lines: ["Dave's", "Story"], href: "#story", slug: "daves-story" },
  { lines: ["Dave's", "Platform"], href: "#platform", slug: "daves-platform" },
  { lines: ["Resolution", "Solutions"], href: "#day-one", slug: "resolution-solutions" },
  { lines: ["Referendum", "Solutions"], href: "#referendum", slug: "referendum-solutions" },
  { lines: ["Upcoming", "Events"], href: "#events", slug: "upcoming-events" },
  { lines: ["Volunteer", "Meet with Dave"], href: "#volunteer", slug: "volunteer-meet-dave" },
  { lines: ["Plan", "to Vote"], href: "#vote", slug: "plan-to-vote" },
];

export default function Navbar({ onNavigate }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-navy border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-center px-4 md:px-10 py-2 md:py-0 md:h-20">
        <div className="flex flex-wrap items-center justify-evenly w-full gap-y-1 gap-x-3 md:gap-x-0">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => onNavigate(l.href)}
              className={`text-[10px] md:text-xs uppercase tracking-[0.12em] md:tracking-[0.18em] font-semibold text-center leading-snug transition-colors duration-300 ${scrolled ? "text-[#F8F9FA]/70 hover:text-[#F8F9FA]" : "text-navy hover:text-electric"}`}
              data-testid={`nav-link-${l.slug}`}
            >
              <span className="block">{l.lines[0]}</span>
              <span className="block">{l.lines[1]}</span>
            </button>
          ))}
        </div>
      </nav>
    </motion.header>
  );
}
